module.exports = __webpack_public_path__ + "static/media/icon-towtruck.6fe30923.svg";